import { createApp, Plugin } from "vue";
import App from "./app.vue";
import router from "@/router/router";
import i18n from "@/i18n";
import vClickOutside from "click-outside-vue3";
import vModal from "./directives/vModal";
import { VueMasonryPlugin } from "vue-masonry";
import MiddlewarePlugin from "vue-router-middleware-plugin";
import appMiddleware from "./router/middleware/appMiddleware.ts";
import "./utils/bugsnag";
import "./utils/gtm";
import "bootstrap/js/src/collapse.js";
import "bootstrap/js/src/modal.js";
import "bootstrap/js/src/dropdown.js";
import { getTld } from "@/utils/urlHelper";
import ioMiddleware from "@/router/middleware/ioMiddleware.ts";
import VueLazyLoad from "vue3-lazyload";
import LazyComponent from "v-lazy-component";
import { createPinia } from "pinia";
import { useVisitStore } from "@/store/visit";
import { loadLanguage, setVisitUid, VISIT_UID_KEY } from "@/utils/storage";
import { getCookie } from "@/utils/cookies";

const app = createApp(App);
app.config.compilerOptions.whitespace = "preserve";
app.config.compilerOptions.isCustomElement = (tag) => ["center"].includes(tag);

const pinia = createPinia();
const visitCookie = getCookie(VISIT_UID_KEY);

if (visitCookie) {
  setVisitUid(visitCookie);
}

void useVisitStore(pinia).ensureVisitTracked((loadLanguage() || document.documentElement.getAttribute("lang") || "en") as "en" | "de" | "fr");

app.use(VueMasonryPlugin).use(VueLazyLoad, {}).use(LazyComponent).use(vClickOutside).use(pinia).use(router).use(i18n);

app.use(MiddlewarePlugin as unknown as Plugin, {
  router,
  middleware: getTld() !== "io" ? appMiddleware : ioMiddleware,
  context: { pinia },
});

app.directive("modal", vModal);

app.mount("#app");
